import Marquee from "react-fast-marquee";
import { Divider } from "retro-react";

function RainbowDivider() {
  return (
    <>
      <Divider
        color="rainbow"
        orientation="horizontal"
        style={{
          marginTop: 15,
          marginBottom: 15,
        }}
      />
    </>
  );
}

export default RainbowDivider;
